import { getContentPage } from '@/api/content';
import { Author, AuthorState } from '@/types/author';
import { Content } from '@/types/content';
import { RootState } from '@/types/store';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';

type AuthorsGetter = GetterTree<AuthorState, RootState>;

const state: AuthorState = {
  authors: [],
};

const getters: AuthorsGetter = {
  authors: state => state.authors,
};

const actions: ActionTree<AuthorState, RootState> = {
  async getAuthorList({ commit }): Promise<void> {
    const { data } = await getContentPage(1, 'authors');
    const authors = data.map(({ id, meta }: Content) => {
      return {
        id,
        name: meta.title,
      };
    });
    commit('setAuthors', authors);
  },
};

const mutations: MutationTree<AuthorState> = {
  setAuthors(state: AuthorState, authors: Author[]): void {
    state.authors = authors;
  },
};

const authors: Module<AuthorState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
};

export default authors;
